import React from 'react';
import { Sun, CloudSun, Cloud, CloudRain, CloudSnow, CloudLightning, CloudFog, Wind, Thermometer } from 'lucide-react';

const STONE = '#8C8275';
const RUST  = '#A13D2D';

// Condition codes come from weather-service's conditionToCode().
const ICONS = {
  sunny: Sun, 'partly-cloudy': CloudSun, cloudy: Cloud, rain: CloudRain,
  snow: CloudSnow, storm: CloudLightning, fog: CloudFog, wind: Wind,
};
const LABELS = {
  sunny: 'Sunny', 'partly-cloudy': 'Partly cloudy', cloudy: 'Cloudy', rain: 'Rain',
  snow: 'Snow', storm: 'Thunderstorms', fog: 'Fog', wind: 'Windy',
};

// Conditions that make an exterior install day doubtful get the warning color.
export function isRoughWeather(forecast) {
  if (!forecast) return false;
  return ['snow', 'storm', 'rain'].includes(forecast.condition) || forecast.tempF <= 20;
}

export default function WeatherBadge({ forecast, showLabel = false, size = 13 }) {
  if (!forecast) return null;
  const Icon = ICONS[forecast.condition] || Thermometer;
  const color = isRoughWeather(forecast) ? RUST : STONE;
  const label = LABELS[forecast.condition];
  return (
    <span
      title={`${label ? `${label}, ` : ''}${forecast.tempF}°F (Milbank forecast)`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', fontSize: '11px', fontWeight: '600', color }}
    >
      <Icon size={size} strokeWidth={2} />
      {forecast.tempF}°{showLabel && label ? ` · ${label}` : ''}
    </span>
  );
}
